import React from "react";
import {
  FormGroup,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Alert,
} from "reactstrap";
// import { EnterClick } from "../../hooks/EnterClick";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";

import BotaoOk from "../BotaoOk";
const ModalSucesso = (props) => {
  // EnterClick(props.toggle, "Enter");

  return (
    <div>
      <Modal isOpen={props.isOpen} toggle={props.toggle} centered>
        <ModalHeader toggle={props.toggle}>Informação</ModalHeader>
        <ModalBody>
          <FormGroup className="row mb-0">
            <div className="col-sm-12">
              <Alert color="success">
                <CheckCircleOutlineIcon
                  style={{ color: "#00AB03", fontSize: 45 }}
                />
                <span className="ml-2">{props.sucesso.mensagem}</span>
              </Alert>
            </div>
          </FormGroup>
        </ModalBody>
        <ModalFooter>
          <BotaoOk className="m-1" onClickOk={props.toggle} />
        </ModalFooter>
      </Modal>
    </div>
  );
};

export default ModalSucesso;
